import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

import { GlobalProvider } from './context/GlobalContext'
import { AuthProvider } from './context/AuthContext'
import { VIPAuthProvider } from './context/VIPAuthContext'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <VIPAuthProvider>
        <GlobalProvider>
          <App />
        </GlobalProvider>
      </VIPAuthProvider>
    </AuthProvider>
  </StrictMode>,
)
